import type { WrittenPage } from '../../sections'
import { PDF } from '../ebook-top-10-secrets'

/**
 * "Top 10 Secrets to Succeeding with AI" e-kitabı — Türkçe.
 *
 * Bölüm sırası, görseller ve maddeler İngilizcesiyle birebir aynı; değişen
 * yalnızca nasıl söylendiği. E-kitabın adı kapağında basılı olduğu için
 * İngilizce kalıyor; "governance", "predictive analytics", "time-to-market"
 * gibi yerleşik terimler de öyle. Marka adları olduğu gibi kalıyor.
 *
 * İndirilen dosya İngilizce — e-kitabın Türkçesi yok. Bu, sayfayı Türkçe
 * yazmamak için bir sebep değil: sayfayı okuyup indirme kararını veren kişi
 * Türkiye'deki okur, ve karar Türkçe veriliyor.
 *
 * Formla ilgili açık soru İngilizce sayfada duruyor ve orada bir kez duruyor:
 * `check` iki dilde tekrarlanınca aynı karar iki not olarak sayılıyor.
 */
export const ebookTop10Secrets: WrittenPage = {
  navLabel: 'AI’da başarının 10 sırrı',
  title: 'Top 10 Secrets to Succeeding with AI',
  description:
    'AI’ı operasyonlarınıza taşımak için uygulanabilir içgörüler, gerçek örnekler ve denenmiş stratejiler. Digitopia Impact Labs’in e-kitabını indirin.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'İşinizi bugün dönüştürün',
      headline: 'Top 10 Secrets to Succeeding with AI',
      body: [
        'İşinizi Artificial Intelligence’ın gücüyle nasıl baştan kuracağınızı keşfedin. '
          + 'Kapsamlı e-kitabımız; AI’ı operasyonlarınıza taşımanız ve büyümeyi hızlandırmanız '
          + 'için uygulanabilir içgörüler, gerçek hayattan case study’ler ve denenmiş stratejiler '
          + 'sunuyor.',
      ],
      ctas: [{ label: 'İndirin', href: PDF }],
      photo: {
        src: '/photo/top-10-secrets-ebook-artwork.webp',
        alt:
          'E-kitabın kapak görseli: gece, ışıklı gökdelenlerin arasından geçen bir bulvar; '
          + 'trafiğin farları uzun ışık çizgilerine dönüşmüş.',
      },
      photoFrame: 'square',
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'Bu e-kitabı neden indirmelisiniz?',
      points: [
        'Uygulanabilir içgörüler: AI’ı müşteri deneyimini kişiselleştirmek, operasyonu '
          + 'iyileştirmek ve pazarlamayı güçlendirmek için nasıl kullanacağınızı öğrenin.',
        'Gerçek örnekler: Amazon, Coca-Cola ve Google gibi lider şirketlerin öne geçmek için '
          + 'AI’ı nasıl kullandığını görün.',
        'Uygulanabilir stratejiler: AI yetkinliklerini kurmak, güçlü bir governance sağlamak ve '
          + 'AI verisiyle stratejik karar almak için adım adım yol gösterimi.',
      ],
      ctas: [{ label: 'E-kitabı indirin', href: PDF }],
      photo: {
        src: '/photo/top-10-secrets-ebook-covers.webp',
        alt:
          'Top 10 Secrets e-kitabının iki kopyası, biri diğerinin arkasında, açık renkli '
          + 'gradyan bir zeminde.',
      },
    },
    {
      kind: 'cta',
      tone: 'card',
      heading: 'Neler öğreneceksiniz?',
      points: [
        'Müşteri deneyimini kişiselleştirme: AI destekli kişiselleştirmeyle müşteri sadakatini '
          + 've memnuniyetini artırın.',
        'Operasyonu iyileştirme: AI destekli otomasyon ve predictive maintenance ile süreçleri '
          + 'sadeleştirin, maliyeti düşürün.',
        'Satışı büyütme: Predictive analytics ile müşteri ihtiyacını önceden görün, satış '
          + 'stratejinizi buna göre kurun.',
        'Ürün geliştirmede yenilik: AI içgörüleriyle ürün inovasyonunu hızlandırın, '
          + 'time-to-market’i kısaltın.',
        'Stratejik karar alma: Rekabette önde kalmak için veriye dayalı, bilinçli kararlar '
          + 'verin.',
      ],
      ctas: [{ label: 'E-kitabı indirin', href: PDF }],
      photo: {
        src: '/photo/top-10-secrets-ebook-stack.webp',
        alt: 'Top 10 Secrets e-kitabının basılı kopyalarından oluşan bir yığın, yukarıdan.',
      },
    },
    {
      kind: 'prose',
      heading: 'Topluluğumuza katılın',
      sub:
        'AI’daki güncel trendleri ve içgörüleri takip edin. Özel içerik ve güncellemeler için '
        + 'bizimle iletişime geçin.',
      cta: { label: 'Bize Ulaşın', href: '#contact' },
    },
    {
      kind: 'prose',
      align: 'center',
      heading: 'Kaçırmayın!',
      sub:
        'Ücretsiz e-kitabımızı bugün indirin ve AI’da başarıya giden yolculuğunuza başlayın. '
        + 'Sektör liderlerinin dikkat çekici sonuçlar için kullandığı sırlarla işinizi '
        + 'dönüştürün.',
      cta: { label: 'E-kitabı indirin', href: PDF },
    },
  ],
}
